import { z } from 'zod';

const cameraChannelStrategyParamsZod = z.object({
  channels: z.array(z.string()).default([]),
});

export type CameraChannelStrategyParams = z.infer<
  typeof cameraChannelStrategyParamsZod
>;

export const emptyStrategyParamsZod = z.object({}).default({});

export const pickupStrategyZod = z.discriminatedUnion('strategy_type', [
  z.object({
    strategy_type: z.literal('CAMERA_CHANNEL'),
    strategy_params: cameraChannelStrategyParamsZod.default({ channels: [] }),
  }),
  z.object({
    strategy_type: z.literal('FIFO'),
    strategy_params: emptyStrategyParamsZod,
  }),
  z.object({
    strategy_type: z.literal('RANDOM'),
    strategy_params: emptyStrategyParamsZod,
  }),
  z.object({
    strategy_type: z.literal('FRAME_COUNT'),
    strategy_params: emptyStrategyParamsZod,
  }),
  z.object({
    strategy_type: z.literal('ANNOTATION_COUNT'),
    strategy_params: emptyStrategyParamsZod,
  }),
]);

export type PickupStrategy = z.infer<typeof pickupStrategyZod>;
export type PickupStrategyType = PickupStrategy['strategy_type'];

const pickupStrategyMeta = z.object({
  sample_group_token: z.string(),
  created_at: z.coerce.date(),
  updated_at: z.coerce.date(),
});

export const pickupStrategyRowZod = z.intersection(
  pickupStrategyMeta,
  pickupStrategyZod
);

export type PickupStrategyRow = z.infer<typeof pickupStrategyRowZod>;

export const DEFAULT_QA_AUDIT_PICKUP_STRATEGY: PickupStrategy = {
  strategy_type: 'RANDOM',
  strategy_params: {},
};

export const DEFAULT_LABELING_PICKUP_STRATEGY: PickupStrategy = {
  strategy_type: 'FIFO',
  strategy_params: {},
};
